var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Element from './Element';
import * as mat3 from '../../js/mat3';
import * as lodash from '../utils/lodash';
var Marker = /** @class */ (function (_super) {
    __extends(Marker, _super);
    function Marker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'marker';
        _this.svgTagName = 'marker';
        return _this;
    }
    Marker.prototype.getDefaultAttr = function () {
        return {
            x: 0,
            y: 0,
            width: 3,
            height: 3,
            orient: 0,
            markerUnits: 'strokeWidth',
        };
    };
    Marker.prototype.renderMarker = function (painter, parent, position) {
        var matrix = this._getMarkerMatrix(parent, position);
        var ctx = painter.getContext();
        ctx.save();
        ctx.transform(matrix[0], matrix[1], matrix[3], matrix[4], matrix[6], matrix[7]);
        painter.drawElement(this.attr.shape);
        ctx.restore();
    };
    Marker.prototype.getMarkerDirtyRect = function (parent, position) {
        var globalMatrix = parent.getGlobalTransform();
        var matrix = this._getMarkerMatrix(parent, position);
        var _a = this.attr.shape.getCurrentDirtyRect(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        var out = { x: 0, y: 0, width: 0, height: 0 };
        return this.computeBBoxWithTransform(out, x, y, width, height, mat3.multiply(matrix, globalMatrix, matrix));
    };
    Marker.prototype.getSvgAttributes = function () {
        var _a = this.attr, x = _a.x, y = _a.y, width = _a.width, height = _a.height, orient = _a.orient, shape = _a.shape, markerUnits = _a.markerUnits;
        var shapeBBox = shape.getBBox();
        return {
            id: this.getMarkerId(),
            refX: x,
            refY: y,
            markerWidth: width,
            markerHeight: height,
            viewBox: [shapeBBox.x, shapeBBox.y, shapeBBox.width, shapeBBox.height].join(' '),
            orient: lodash.isNumber(orient) ? (orient * 180) / Math.PI : orient,
            markerUnits: markerUnits,
        };
    };
    Marker.prototype.getMarkerId = function () {
        return "lighthcarts-marker-" + this.id;
    };
    Marker.prototype._getMarkerMatrix = function (parent, position) {
        var out = mat3.createVec3();
        var path = parent.getPathData();
        var _a = this.attr, x = _a.x, y = _a.y, width = _a.width, height = _a.height, orient = _a.orient, shape = _a.shape, markerUnits = _a.markerUnits;
        var bbox = shape.getBBox();
        var sx = width / bbox.width;
        var sy = height / bbox.height;
        var lineWidthScale = 1;
        var rotate = orient;
        var percent = 0;
        if (position === 'start') {
            percent = 0;
        }
        else if (position === 'middle') {
            percent = 0.5;
        }
        else if (position === 'end') {
            percent = 1;
        }
        if (markerUnits === 'strokeWidth') {
            lineWidthScale = parent.getExtendAttr('lineWidth');
        }
        var point = path.getPointAtPercent(percent);
        if (orient === 'auto' || orient === 'auto-start-reverse') {
            rotate = point.alpha;
        }
        if (orient === 'auto-start-reverse' && position === 'start') {
            rotate = point.alpha - Math.PI;
        }
        mat3.translate(out, out, [point.x, point.y]);
        if (rotate !== 0) {
            mat3.rotate(out, out, rotate);
        }
        mat3.scale(out, out, [sx * lineWidthScale, sy * lineWidthScale]);
        mat3.translate(out, out, [-x, -y]);
        return out;
    };
    return Marker;
}(Element));
export default Marker;
